import React, { useCallback, useContext, useState } from "react";
import { View, ScrollView } from "react-native";
import { Text, ActivityIndicator } from "react-native-paper";
import { useFocusEffect, useIsFocused } from "@react-navigation/native";
import { PreferencesContext } from "../Contexts/PreferencesContext";
import LessonPanel from "../Components/Home/LessonPanel";
import { getLearnedLessons } from "../Api/Statistics";
import { useNewWindowDimensions } from "../Functions/WindowDimensions";
import { useTheme } from "../Contexts/ThemeContext";

const LearnPage = () => {
  const windowSize = useNewWindowDimensions();
  const reSize = Math.min(windowSize.width, windowSize.height) / 25;

  const { theme } = useTheme();

  const { updateLearnedLessons, learnedLessons } =
    useContext(PreferencesContext);

  const [areLessonsLoaded, setLessonsLoaded] = useState(false);

  useFocusEffect(
    useCallback(() => {
      // This determines what lessons the user has learned and conditionally displays everything.
      async function getUserLearnedLessons() {
        await getLearnedLessons().then((lessons: any) => {
          if (lessons !== null) {
            // prevent the infinite loop
            if (learnedLessons !== lessons && !areLessonsLoaded) {
              updateLearnedLessons(lessons);
            }
            setLessonsLoaded(true);
          }
        });
      }
      getUserLearnedLessons();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [learnedLessons]),
  );

  const isFocused = useIsFocused();
  if (!isFocused) return <Text>Error Loading Page</Text>;

  return (
    <ScrollView style={{ width: windowSize.width, height: windowSize.height }}>
      <View style={{ flexDirection: "row" }}>
        <View
          style={{
            flexDirection: "column",
            flexGrow: 1,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                color: theme.semantic.text.primary,
                fontSize: 50,
                lineHeight: 50,
                fontWeight: "bold",
              }}
            >
              Learn{" "}
              <Text
                style={{
                  color: theme.useDarkTheme
                    ? theme.semantic.text.inverse
                    : theme.semantic.text.info,
                }}
              >
                Sudoku
              </Text>
            </Text>
          </View>
          <View style={{ alignItems: "center", alignSelf: "center" }}>
            {areLessonsLoaded ? (
              <View style={{ padding: reSize / 4 }}>
                <LessonPanel
                  width={windowSize.width}
                  height={windowSize.height}
                />
              </View>
            ) : (
              <ActivityIndicator
                animating={true}
                color={theme.colors.primary}
              />
            )}
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

export default LearnPage;
